import React from "react";

export default function ImagePlaceholder() {
    return (
      <span className="item-placeholder">
        <i className="icon icon-placeholder" />
      </span>
    );
}



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Atoms/ImagePlaceholder.jsx